<style lang="less">
@import "../../css/core/color";
.el-popover-2 {
  padding: 0 !important;
  width: 204px !important;
  height: 136px !important;
  border: none !important;
  .kefuwrapper {
    display: block;
    padding: 16px 10px;
    width: 204px;
    background-color: #FFFFFF;
    box-shadow: 0 0 10px 1px rgba(0,0,0,0.16);

    .kefu-btn {
      width: 100%;
      padding: 0 14px;
      text-align: left;

      .fs-14 {
        font-size: 14px;
      }

      .fs-12 {
        font-size: 12px;
      }

      .xe-color1 {
        color: #333333;
      }

      .xe-color2 {
        color: #6c748a;
      }

      &:first-child {
        padding-bottom: 16px;
        margin-bottom: 16px;
        border-bottom: 1px solid #e5e5e5;
      }
    }

    .qrcodewrapper {
      position: absolute;
      top: 0;
      left: 201px;

      padding: 26px;
      width: 200px;
      text-align: center;
      background-color: #fff;

      .qrcodeimg {
        width: 140px;
        height: 140px;
      }

      .tiptext {
        margin-top: 4px;
        line-height: 20px;
        font-size: 12px;
        color: #333333;
      }
    }
  }
}

.index {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background: #f5f6fa;

    .topbar {
        position: relative;
        flex:0;
        flex-basis: 80px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        height:80px;
        padding: 21px 35px;
        border-bottom: 1px solid #e5e5e5;

        background: #ffffff;
        // box-shadow: 0px 3px 10px 1px rgba(183, 183, 183, 0.2);



        .left,
        .right {
            display: flex;
            align-items: center;
            font-size: 12px;
            color: #666;
        }

        .right {
            .classname {
                margin-right: 10px;
            }
            .kefu{
                position: relative;
                margin-right: 20px;
                cursor: pointer;

                .xefont{
                    margin-right: 3px;
                }

                .qrcodewrap {
                    display: none;
                    position: absolute;
                    right: -10px;
                    top: 25px;
                    z-index: 2;
                    width: 200px;
                    padding: 22px 30px 16px;
                    text-align: center;
                    background: #FFFFFF;
                    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.16);

                    .qrcodeimg {
                        width: 140px;
                        height: 140px;
                    }

                    .tiptext {
                        margin-top: 4px;
                        line-height: 20px;
                        font-size: 12px;
                        color: #333333;
                    }
                }

                &:hover {
                    .qrcodewrap {
                        display: block;
                    }
                }
            }
            .username {
                margin: 0 14px;
                .user-type {
                    color: #333;
                }
            }
        }
        .left {
            .logo {
                width: 73px;
                height: 38px;
            }
            .title {
                margin-left: 6px;
                font-size: 18px;
                color: #839dfe;
            }
        }
        .apps {
            display: flex;
            align-items: center;
            margin-left: 50px;
        }
        .app {
            margin-right: 15px;
            font-size: 16px;
            line-height: 2.2;
            color: #656565;
            cursor: pointer;
            &.color {
                color: #7691fa;
            }
            &.active {
                border-bottom: 2px solid #7691fa;
            }
        }
        .logout {
            color: #fa7575;
            cursor: pointer;
            font-weight: bold;
            padding-left: 5px;
        }
    }

    .subbar {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #ffffff;
        padding: 30px 0 0;
        border: 1px solid #f3f3f3;
        .app {
            margin-right: 36px;
            font-size: 16px;
            color: #656565;
            cursor: pointer;
            padding-bottom: 10px;
            &.active {
                border-bottom: 2px solid #7691fa;
                color: #7691fa;
            }
        }
    }

    .index-con{
        position: relative;
        flex:1;
        height: 0;
        overflow: auto;


        .sidebar-container {
            position: absolute;
            top:0;
            left: 0;
            overflow-x: hidden;
            overflow-y: auto;
            width: 200px;
            height: 100%;
            padding-top: 24px;
            background-color: #FAFBFC;
            .el-menu {
                border-right: 0;
                background-color: #FAFBFC;
            }
            .wxfont {
                margin-right: 15px;
            }
        }

        .main-container {
            position: relative;
            overflow: auto;
            height: 100%;
            margin-left: 200px;
            background: #fff;
            .wrap{
                padding:15px 0 0 15px;
            }
        }

    }


  .guide-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;

    .mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
    }

    .guide-content {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 17px 26px;
      width: 405px;
      background: linear-gradient( 90deg, #76BCFA 0%, #7691FA 100%);
      border-radius: 16px;
      z-index: 999;

      &.guide-1 {
        top: 355px;
        left: 107px;
      }

      .left {
        .title {
          font-size: 24px;
          color: #FFFFFF;
        }
        .desc {
          font-size: 18px;
          color: #FFFFFF;
        }
      }

      .right {
        width: 130px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 18px;
        color: @color;
        border-radius: 31px;
        background-color: #fff;
      }

      .triangle-up {
        position: absolute;
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 16px solid #76BCFA;

        &.triangle-1 {
          top: -10px;
          left: 23px;
        }
      }
    }

    .target {
      position: absolute;

      &.target-1 {
        display: flex;
        align-items: center;

        top:216px;
        left: 0;
        padding-left: 16px;
        width: 191px;
        height: 51px;
        font-size: 14px;
        color: @color2;
        background-color: #fff;

        .icon {
          margin-right: 18px;
          width: 20px;
          height: 20px;
        }
      }
    }

    .dot {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;

      width: 20px;
      height: 20px;
      border-radius: 50%;

      background-color: rgba(255,255,255,0.3);


      &.dot-1 {
        top: 267px;
        left: 130px;
      }


      &::after {
        position: absolute;
        top:20px;
        left: 50%;
        transform: translateX(-50%);
        content: '';
        height: 80px;
        width: 1px;
        background-color: #fff;
      }

      .dot-center {
        width: 11px;
        height: 11px;
        background-color: #fff;
        border-radius: 50%;
      }
    }
  }
}

.wrap-date {
    display: flex;
    align-items: center;
    padding: 0 20px;
    position: relative;
    .wrap-el-time {
        &.pr {
            position: relative;
            display: inline-block;
        }
    }
    .el-dropdown-link {
        &.fs {
            font-size: 14px;
        }
    }
    .wxfont-arrow-down {
        margin-left: 8px;
        font-size: 12px;
        color: #949494;
    }
    &::after {
        left: inherit;
        right: 0;
    }
}
.el-dropdown {
    color: #7691fa;
    font-size: 16px;

}
.el-dropdown-menu {
    width: 200px !important;
    z-index: 2001!important;
    background-color: #fff;
}

.el-dropdown-menu__item {
  width: 100%!important;
  padding: 20px !important;
}
.wrap-date::before, .wrap-date::after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 30px;
    width: 1px;
    background-color: #707070;
    opacity: 0.3;
}



// .el-submenu__title:hover, .el-menu-item:focus, .el-menu-item:hover {
//     background-color: #f5f6fa;
// }
.el-menu-item, .el-submenu__title {
  // height: 46px;
  // line-height: 46px;
  &:hover {
    background-color: #EBEFFF;
  }
}
.el-menu-item, .el-submenu__title {
    color: #6C748A;
}

.el-menu-item {
    &.is-active {
        color: #7691fa;
    }
}



.tags-view-container {
    padding: 10px 0;
    margin-left: 220px;
    background-color: #f5f6fa;
}
.appIcon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
}


@media (max-width: 1200px) {
	.index .topbar .apps{ margin-left: 30px;}
	.index .topbar .app{margin-right:14px;}
	.index .topbar .right .username{margin: 0 10px;}
	.wrap-date{padding: 0 12px;}
}
</style>


<template lang="html">
	<div class="index" v-if="isReady">
        <!-- <div class="wrap-topbar"> -->
            <div id="topbar" class="topbar">
                <div class="left">
                    <img src="./images/logo.png" class="logo"><span class="title">智校</span>
                    <!-- <div class="apps">
                        <div class="app" :class="{'color':0==mainMenuIndex}" @click="switchMainMenu(0)" >学校管理</div>
                        <div v-if="sendSchoolNoticeOpen" class="app" :class="{'color':1==mainMenuIndex}" @click="switchMainMenu(1)" >通知</div>
                        <div v-if="sendSchoolRecipeOpen" class="app" :class="{'color':2==mainMenuIndex}" @click="switchMainMenu(2)" >食谱</div> -->
						<!-- <div v-if="sendSchoolTiwenOpen" class="app" :class="{'color':3==mainMenuIndex}" @click="switchMainMenu(3)" >体温</div> -->
                        <!-- <div class="app" :class="{'color':10==mainMenuIndex}" @click="switchMainMenu(10)" >素质活动</div>
						<div v-if="sendSchoolQingjia" class="app" :class="{'color':4==mainMenuIndex}" @click="switchMainMenu(4)" >请假</div>
						<div v-if="sendSchoolOffical" class="app" :class="{'color':5==mainMenuIndex}" @click="switchMainMenu(5)" >微官网</div>
                        <div v-if="sendSchoolRecipeOpen" class="app" :class="{'color':6==mainMenuIndex}" @click="switchMainMenu(6)" >成绩</div>
                        <div  class="app" :class="{'color':7==mainMenuIndex}" @click="switchMainMenu(7)" >应用及服务</div>
                        <div  class="app" :class="{'color':8==mainMenuIndex}" @click="switchMainMenu(8)">学校相册</div>
                        <div  class="app" :class="{'color':9==mainMenuIndex}" @click="switchMainMenu(9)">综合评价</div>
                    </div> -->
                </div>
                <div class="right">
                    <!--客服-->
                    <div class="kefu flex-ai-center">
                      <el-popover
                        popper-class="el-popover-2"
                        placement="bottom">
                        <div class="kefuwrapper">
                          <div class="kefu-btn" @click="qrCodeShow = !qrCodeShow">
                            <div class="fs-14 xe-color1">在线人工客服</div>
                            <div class="fs-12 xe-color2">专业在线解答</div>
                          </div>
                          <div class="kefu-btn" @click="goQuestion">
                            <div class="fs-14 xe-color1">反馈与调研</div>
                            <div class="fs-12 xe-color2">邀请参与调研，收集反馈意见</div>
                          </div>

                          <div class="qrcodewrapper shadow" v-if="qrCodeShow">
                            <img class="qrcodeimg" :src="kfQrCode" alt="">
                            <div class="tiptext">
                              <div>扫上方二维码</div>
                              <div>联系专属人工客服</div>
                            </div>
                          </div>
                        </div>
                        <template slot="reference">
                          <div>
                            <span class="xefont xefont-kefu fs-16"></span>
                            <span>客服</span>
                          </div>
                        </template>
                      </el-popover>
                    </div>

					<span class="username">学校码: {{currentSchoolCode}} </span>
                    <div class="wrap-date">
                        <div class="wrap-el-time pr">
                            <el-dropdown placement="top-start">
                                <span class="el-dropdown-link fs"> {{  currentSchoolName }} <i class="wxfont wxfont-arrow-down" v-if="schoolList.length > 1"></i> </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for=" item in schoolList "
                                                          v-if=" currentSchoolCode!= item.schoolCode"
                                                          :key="item.schoolCode"
                                                          @click.native="onSchoolSwitch(item.schoolCode)"
                                                          class="dropdown-item">
                                          {{item.schoolName}}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
					          <span class="username" @click="goUserInfo">{{userName}} <span class="user-type">{{currentSchoolTitle}}</span></span>
                    <span class="logout" @click="doLogout" ><i class="wxfont wxfont-jieshu"></i></span>

                </div>
            </div>
        <!-- </div> -->
        <!-- <div class="subbar" v-if="mainMenuIndex==0">
            <div class="app" :class="{'active':0==subMenuIndex}" @click="goUserslist()" >成员管理</div>
            <div class="app" :class="{'active':1==subMenuIndex}" @click="goClazzlist()" >班级管理</div>
        </div>
        <div class="subbar" v-if="mainMenuIndex==5">
            <div class="app" :class="{'active':0==subMenuIndex}" @click="goMpManager()" >公众号管理</div>
            <div class="app" :class="{'active':1==subMenuIndex}" @click="openWgw()" >打开微官网</div>
        </div> -->
        <div class="index-con"><!--  v-if="!qyVipData.isExpire"> -->
            <div class="sidebar-container">
                <el-menu>
                    <el-menu-item index="14" @click="switchMainMenu(14)">
                        <img v-if="mainMenuIndex == 14" class="appIcon" src="./images/appIcon/activation_sj.png"/>
                        <img v-else class="appIcon" src="./images/appIcon/normal_sj.png"/>
                        <span slot="title">使用数据</span>
                    </el-menu-item>
                    <el-submenu index="15">
                        <div slot="title">
                            <img v-if="mainMenuIndex == 15" class="appIcon" src="./images/appIcon/activation_ph.png"/>
                            <img v-else class="appIcon" src="./images/appIcon/normal_ph.png"/>
                            <span>使用排行</span>
                        </div>
                        <el-menu-item index="15-1" @click="goWeekPaper()">周报</el-menu-item>
                        <el-menu-item index="15-2" @click="goMonthPaper()">月报</el-menu-item>
                        <el-menu-item index="15-3" @click="goTermPaper()">学期</el-menu-item>
                        <el-menu-item index="15-4" @click="goYearPaper()">学年</el-menu-item>
                    </el-submenu>
                    <el-submenu index="1" v-if="userManageOpen">
                        <div slot="title">
                            <img v-if="mainMenuIndex == 1" class="appIcon" src="./images/appIcon/xuexiaoguanli_active.png"/>
                            <img v-else class="appIcon" src="./images/appIcon/normal_xxgl.png"/>
                            <span>学校管理</span>
                        </div>
                        <el-menu-item index="1-1" @click="goUserslist()">成员管理</el-menu-item>
                        <el-menu-item index="1-2" @click="goClazzlist()">班级管理</el-menu-item>
                        <el-menu-item index="1-3" @click="goReviewlist()">班级加入审核</el-menu-item>
                    </el-submenu>
                    <el-submenu index="16">
                        <div slot="title">
                            <img v-if="mainMenuIndex == 16" class="appIcon" src="./images/appIcon/activation_jxhd.png"/>
                            <img v-else class="appIcon" src="./images/appIcon/jxhd.png"/>
                            <span>家校互动</span>
                        </div>
                        <el-menu-item v-if="sendSchoolNoticeOpen" index="16-1" @click="switchMainMenu(1)">全校通知</el-menu-item>
                        <el-menu-item v-if="sendCollectOpen" index="11" @click="switchMainMenu(11)">全校信息收集</el-menu-item>
                        <el-submenu v-if="sendSchoolQingjia" index="16-2">
                            <div slot="title">请假&考勤</div>
                            <el-menu-item index="16-2-1" @click="goClassStat()">班级考勤统计</el-menu-item>
                            <el-menu-item index="16-2-2" @click="goHealthCheck()">晨午晚检上报情况</el-menu-item>
                            <el-menu-item index="16-2-3" @click="goStudentStat()">学生考勤统计</el-menu-item>
                            <el-menu-item index="16-2-4" @click="goLeaveSetting()">请假设置</el-menu-item>
                            <el-menu-item index="16-2-5" @click="goLeaveApprove()">请假审批</el-menu-item>
                        </el-submenu>
                        <el-submenu v-if="sendScoreOpen" index="16-3">
                            <div slot="title">成绩</div>
                            <el-menu-item index="16-3-1" @click="goQueryScore()">年级成绩</el-menu-item>
                            <el-menu-item index="16-3-2" @click="goClassScore()">班级成绩</el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="sendSchoolRecipeOpen" index="16-4" @click="switchMainMenu(2)">校园食谱</el-menu-item>
                        <el-menu-item index="16-5" @click="switchMainMenu(16)">班级小精灵</el-menu-item>
                    </el-submenu>
                    <el-submenu v-if="sendSchoolCkOpen" index="12">
                        <div slot="title">
                            <img v-if="mainMenuIndex == 12" class="appIcon" src="./images/appIcon/daka_active.png"/>
                            <img v-else class="appIcon" src="./images/appIcon/normal_dk.png"/>
                            <span>AI作业打卡</span>
                        </div>
                        <el-menu-item index="12-1" @click="switchMainMenu(12)">全校打卡</el-menu-item>
                    </el-submenu>
                    <el-submenu v-if="sendClassPerfOpen" index="10">
                        <div slot="title">
                            <img v-if="mainMenuIndex == 10" class="appIcon" src="./images/appIcon/DeYuPingJia_2.png"/>
                            <img v-else class="appIcon" src="./images/appIcon/DeYuPingJia_1.png"/>
                            <span>德育评价</span>
                        </div>
                        <el-menu-item index="10-1" @click="goClassTargetManagerlist()">班级考评指标</el-menu-item>
                        <el-menu-item index="10-2" @click="goClassReviewManger()">优秀班级评比</el-menu-item>
                        <el-menu-item index="10-3" @click="goClassEvaluationDetails()">班级考评明细</el-menu-item>
                        <el-menu-item index="10-4" @click="goStudentTargetManagerlist()">学生评测指标</el-menu-item>
                        <el-menu-item index="10-5" @click="goStudentEvaluationDetails()">学生评价明细</el-menu-item>
                        <el-menu-item index="10-6" @click="goStudentEvaluationClassexchangelist()">班级奖励兑换记录</el-menu-item>
                    </el-submenu>
                    <el-submenu v-if="screenManageOpen" index="18">
                        <div slot="title">
                            <img v-if="mainMenuIndex == 18" class="appIcon" src="./images/appIcon/ZhiAnTong_2.png"/>
                            <img v-else class="appIcon" src="./images/appIcon/ZhiAnTong_1.png"/>
                            <span>智安通</span>
                        </div>
                        <el-menu-item index="18-1" @click="switchMainMenu(15)">接送大屏</el-menu-item>
                    </el-submenu>
                    <el-submenu v-if="sendSchoolOffical" index="6">
                        <div slot="title">
                            <img v-if="mainMenuIndex == 6" class="appIcon" src="./images/appIcon/weiguanwang_active.png"/>
                            <img v-else class="appIcon" src="./images/appIcon/weiguanwang.png"/>
                            <span>微官网</span>
                        </div>
                        <el-menu-item index="6-1" @click="goMpManager()">公众号管理</el-menu-item>
                        <el-menu-item index="6-2" @click="openWgw()">打开微官网</el-menu-item>
                    </el-submenu>
                    <el-menu-item v-if="isQySchool" index="17" @click="goPxk">
                        <img v-if="mainMenuIndex == 17" class="appIcon" src="./images/appIcon/activation_pxk.png"/>
                        <img v-else class="appIcon" src="./images/appIcon/normal_pxk.png"/>
                        <span slot="title">排选课</span>
                    </el-menu-item>
                    <el-submenu v-else index="17">
                        <div slot="title">
                            <img class="appIcon" src="./images/appIcon/normal_pxk.png"/>
                            <span>排选课</span>
                        </div>
                        <el-submenu index="17-1">
                            <div slot="title" style="color: #aa9c97">校内选课</div>
                            <el-menu-item index="17-1-1" @click="switchMainMenu(171)">选课任务</el-menu-item>
                            <el-menu-item index="17-1-2" @click="switchMainMenu(172)">调课/代课</el-menu-item>
                        </el-submenu>
                        <el-submenu index="17-2">
                            <div slot="title" style="color: #aa9c97">排课</div>
                            <el-menu-item index="17-2-1" @click="switchMainMenu(173)">智能排课</el-menu-item>
                            <el-menu-item index="17-2-2" @click="switchMainMenu(174)">走班排课</el-menu-item>
                        </el-submenu>
                    </el-submenu>
                    <el-menu-item v-if="!qyVipData.chargeCode" index="19" @click="switchMainMenu(18)">
                        <img v-if="mainMenuIndex == 19" class="appIcon" src="./images/appIcon/activation_xuefei.png"/>
                        <img v-else class="appIcon" src="./images/appIcon/normal_xuefei.png"/>
                        <span slot="title">学费收缴</span>
                    </el-menu-item>
                    <el-menu-item index="8" @click="switchMainMenu(7)">
                        <img v-if="mainMenuIndex == 7" class="appIcon" src="./images/appIcon/activation_yyjff.png"/>
                        <img v-else class="appIcon" src="./images/appIcon/normal_yyjff.png"/>
                        <span slot="title">应用及服务</span>
                    </el-menu-item>
                </el-menu>
            </div>
            <!-- <div class="tags-view-container"></div> -->
            <div class="main-container">
                <div class="wrap">
                    <router-view></router-view>
                </div>
            </div>
        </div>
        <!-- <div v-else>
          <qyvipkf></qyvipkf>
        </div> -->

    <!--引导弹窗-->
    <div class="guide-dialog" v-if="isShowGuideMask">
      <div class="mask"></div>
      <div class="guide-content guide-1">
        <div class="left">
          <div class="title">学校管理</div>
          <div class="desc">点这里班级管理、成员管理</div>
        </div>
        <div class="right" @click.stop="goClazzlist">
          下一步(1/3)
        </div>

        <div class="triangle-up triangle-1"></div>
      </div>
      <div class="target target-1">
        <img class="icon" src="./images/appIcon/xuexiaoguanli.png"/>
        学校管理
      </div>
      <div class="dot dot-1">
        <div class="dot-center"></div>
      </div>
    </div>




	</div>
</template>

<script>

import $ from 'jquery';
import qt_util from '@libs/qt/util';
import qt_storage from '@libs/qt/storage';

import _common from '@js/common';
import _config from '@js/config';

import pageMaxin from '@/components/mixins/page';
import vipmixins from '../mixins/vip';
import qyvipkf from '../vip/qyvipkf.vue';

export default {
	name : 'index',
  mixins: [vipmixins, pageMaxin],
	data: function(){
		return {
			avatarUrl:"",
			currentSchoolName:"",
			userName:"",
			currentSchoolCode:'',
			currentSchoolTitle:'',
			schoolList:[], //用户关联到学校列表

      isReady: false,           //  是否准备

      kfQrCode:'',

      qrCodeShow: false,
      isShowGuideMask: false

		}
	},
	components : {
    'qyvipkf': qyvipkf,
	},

	mounted : function(){
		var _this = this;
		// this.fixPosition();
		// $(window).on('resize.index',function(){
		// 	_this.fixPosition();
		// });
		//userManage":true, "sendSchoolNotice":true,  "sendSchoolRecipe":true, "sendSchoolOffical":true
		this.schoolList = this._common.getSchoolList();
		this.refreshUserStat();
        this.initOwnAuthority();
        this.queryVipData().then(res => {
            this.qyVipData = res;
            console.info('this.qyVipData='+JSON.stringify(this.qyVipData));
            this.isReady = true;
        })
        let kfQrCode = qt_storage.sessionGet('kfQrCode');
        if (!kfQrCode) {
            this.doQueryQrCode();
        } else {
            this.kfQrCode = kfQrCode;
        }

        // this.queryGuide()
	},

	computed:{
		mainMenuIndex: function(){
			return this.$store.state.mainMenuIndex;
		},
		subMenuIndex: function(){
			return this.$store.state.subMenuIndex;
		},

        userManageOpen:function(){
            return this.$store.state.userManage;
        },

		sendSchoolNoticeOpen:function(){
			return this.$store.state.sendSchoolNotice;
		},
        sendSchoolCkOpen:function(){
            return this.$store.state.sendSchoolCk;
        },
        sendCollectOpen:function(){
            return this.$store.state.sendCollect;
        },
		sendSchoolRecipeOpen:function(){
			return this.$store.state.sendSchoolRecipe;
		},
        sendScoreOpen:function(){
			return this.$store.state.sendScore;
		},
		sendSchoolTiwenOpen:function(){
			return this.$store.state.sendSchoolTiwen;
		},
		sendSchoolQingjia:function(){
			return this.$store.state.sendSchoolQingjia;
		},
		sendSchoolOffical:function(){
			return this.$store.state.sendSchoolOffical;
		},
        sendClassPerfOpen:function(){
			return this.$store.state.sendClassPerf;
		},
        albumManageOpen:function(){
            return this.$store.state.albumManage;
        },
        screenManageOpen:function(){
			return this.$store.state.screenManage;
		},
        isQySchool:function(){
            return !!this._common.getCorpId();
        },
	},

	methods : {
		//调整高度
		fixPosition: function(){
			var topbar = $('#topbar');
			var topH = topbar.height();
			if(!topH){
				this.waitHeight();
			}else{
				var _vs = qt_util.getViewSize();
				var conH = _vs.height - topH;
				$('#indexCon').css({
					'height' : conH+'px'
				}).attr('data-height',conH);
				this.$store.commit('setIndexConH',conH);
			}
		},
		//等待首次渲染
		waitHeight:function(){
			setTimeout(()=>{
				this.fixPosition();
			},100);
		},


		refreshUserStat:function () {
			this.userName = this._common.getUserName();
			this.currentSchoolCode = this._common.getSchoolCode();
			this.currentSchoolName = this._common.getSchoolName();
			this.currentSchoolTitle = this._common.getSchoolPosition();
		},

		doLogout: function(){
			sessionStorage.clear();
			this.$router.push('/login');
		},

		switchMainMenu:function(mainIndex){
			if(mainIndex==0){
				this.$router.push('/users/list');
			}else if(mainIndex==1){
				this.$router.push('/notice/list');
			}else if(mainIndex==2){
				this.$router.push('/recipe/list');
			}else if(mainIndex==3){
				this.$router.push('/tiwen/list');
			}else if(mainIndex == 4){
        		this.$router.push('/leave/list');
      		}else if(mainIndex == 5){
				this.$router.push('/subcription/index');
			} else if (mainIndex == 6) {
				this.$router.push('/score/list');
			} else if (mainIndex == 7) {
				this.$router.push('/service/index');
			} else if (mainIndex == 8) {
                this.$router.push('/schoolAlbum/index');
            } else if (mainIndex == 9) {
                this.$router.push('/evaluate/index');
            } else if (mainIndex == 10) {
                this.checKWhitelist().then(()=>{
                    this.$router.push('/schoolactivity/list');
                });
            } else if (mainIndex == 11) {
              this.$router.push('/infocollect/list');
            } else if (mainIndex == 12) {
              this.$router.push('/clock/list');
            } else if (mainIndex == 13) {
              this.$router.push('/cloudprint/introduce');
            } else if (mainIndex == 14) {
              this.$router.push('/usestat/dashboard');
            } else if (mainIndex == 15) {
                this.$router.push('/daping/index');
            } else if (mainIndex == 16) {
              this.$router.push('/xiaojingling/statdata');
            }else if(mainIndex == 171){
                this.$router.push('/pxk/index?pageCode=31');
            }else if(mainIndex == 172){
                this.$router.push('/pxk/index?pageCode=24');
            }else if(mainIndex == 173){
                this.$router.push('/pxk/index?pageCode=5');
            }else if(mainIndex == 174){
                this.$router.push('/pxk/index?pageCode=6');
            }else if(mainIndex == 18){
                this.$router.push('/xuefei');
            }
		},

		goWeekPaper: function(){
			this.$router.push('/rank/weekpaper');
		},

		goMonthPaper: function(){
			this.$router.push('/rank/monthpaper');
		},

		goTermPaper: function(){
			this.$router.push('/rank/termpaper');
		},

		goYearPaper: function(){
			this.$router.push('/rank/yearpaper');
		},

        goClazzlist: function(){
      this.isShowGuideMask = false
			this.$router.push('/clazz/list');
		},

    // 企微学校排选课：直接进入排选课首页
    goPxk: function () {
        this.setMainMenuIndex(17);
        this.$router.push('/pxk/index');
    },

    goReviewlist: function () {
      this.$router.push('/review/list');
    },

		goUserslist: function(){
			this.$router.push('/users/list');
		},

		//跳转置公众号管理
		goMpManager: function(){
			this.$router.push('/subcription/index');
		},

    // 跳转个人信息
    goUserInfo: function () {
      this.$router.push('/userinfo/userinfo');
    },

    // 跳转问卷
    goQuestion: function () {
      this.$router.push('/userinfo/question');
    },
    // 跳转班级考勤统计
    goClassStat: function () {
      this.$router.push('/leave/classstat');
    },

    // 跳转晨午晚检上报情况
    goHealthCheck: function () {
      this.$router.push('/leave/healthcheck');
    },

    // 跳转学生考勤统计
    goStudentStat: function () {
      this.$router.push('/leave/studentstat');
    },
    goLeaveSetting: function () {
      this.$router.push('/leave/settings');
    },
    // 跳转请假审批
    goLeaveApprove: function () {
      this.$router.push('/leave/approve');
    },
		//打开微官网
		openWgw: function(){
      this.setMainMenuIndex(6);
			this._postSign({
				url:this._config.SERVICE + '/base/pc/schadm/login/genWgwAccessToken',
				params:{},
				success:(resp)=>{
					if('01' == resp.resultCode){
						let accessToken = resp.data;
						let userInfo = this._common.getUserInfo();

                        // let url = this._config.WGW_PREFIX+'/admin/index.html#/access/'+this.currentSchoolCode+'/'+accessToken+'/article?userId='+userInfo.userId+'&userName='+this.userName+'&schoolName='+this.currentSchoolName
                        // //目前只开放测试学校
                        // let {wgw} = this.$route.query;
                        // if(_common.getSchoolCode()=='442000u9fq4Xdt' && '1'!=wgw){
                        //     let timestamp = (new Date()).getTime();
                        //     //为了不影响v1版本，未发布v2前先代码替换
                        //     let prefix = this._config.WGW_PREFIX.replace(/http\:/,'https:');
                        //     url = prefix+`/adminv2/index.html?v=${timestamp}#/access/`+this.currentSchoolCode+'/'+accessToken+'/content?userId='+userInfo.userId+'&userName='+this.userName+'&schoolName='+this.currentSchoolName
                        // }
                        //全部学校开放v2版本
                        let timestamp = (new Date()).getTime();
                        //为了不影响v1版本，未发布v2前先代码替换
                        let prefix = this._config.WGW_PREFIX;
                        // //正式是https，测试http
                        // if(!this._config.isDev){
                        //     prefix = prefix.replace(/http\:/,'https:');
                        // }
                        let url = prefix+`/adminv2/index.html?v=${timestamp}#/access/`+this.currentSchoolCode+'/'+accessToken+'/content?userId='+userInfo.userId+'&userName='+this.userName+'&schoolName='+this.currentSchoolName

                        console.info('微官网跳转地址------->'+url);
						window.open(url);
					}else{
						console.info('微官网接口失败------->'+JSON.stringify(resp));
						alert('功能暂未开放，敬请期待');
						// this._common.tips(resp.resultMsg);
					}
				},
				fail: (resp) => {
					alert('功能暂未开放，敬请期待');
					// this._common.tips('/base/pc/schadm/mp/getSchoolMpAuthInfo服务异常，请稍后重试'+resp.statusCode);
				}
			});
		},

    // 跳转成绩查询
    goQueryScore () {
      this.$router.push('/score/queryscore');
    },

    // 跳转班级成绩
    goClassScore () {
      this.$router.push('/score/list');
    },

		/**
		 * 切换到某个学校
		 */
		onSchoolSwitch:function (schoolCode) {
			console.log('schoolSwitch => schoolCode: '+ schoolCode);
			if (schoolCode == this.currentSchoolCode)
				return

			this._common.switchSchool(this.$store,schoolCode);
			this.refreshUserStat();
      this.queryVipData().then(res => {
        this.qyVipData = res;
        console.info('this.qyVipData=' + JSON.stringify(this.qyVipData));
      })
			if (this.$route.path === '/usestat/dashboard') {
				location.reload();
			} else {
				this.$router.push('/usestat/dashboard');
			}
		},

        //处理权限
        initOwnAuthority:function(){
			var value = qt_storage.sessionGet('current_school');
			if(value){
				value = JSON.parse(value)
				//设置菜单index
				this.$store.commit('setOwnAuthority',value.authority);
			}
		},


        //检查学校是否有开通
        checKWhitelist:function(){
            return new Promise((resolve,reject)=>{
                let params= {};
                _common.postSign({
                    url:_config.SERVICE + '/clazzalbum/pc/schadm/elect/checKWhitelist',
                    params:params,
                    success:(res)=>{
                        if('01'==res.resultCode){
                            resolve();
                        }else{
                            _common.showMsg(res.resultMsg);
                            reject();
                        }
                    },
                    fail:(res)=>{
                        _common.tips('/elect/checKWhitelist服务异常，请稍后重试');
                        reject();
                    }
                })
            });

        },

        goClassTargetManagerlist: function(){
            this.$router.push('/evaluate/classmange');
        },

        goClassReviewManger: function(){
            this.$router.push('/evaluate/classreviewmanger');
        },

        goClassEvaluationDetails: function(){
            this.$router.push('/evaluate/classcommentdetail');
        },

		goStudentTargetManagerlist: function(){
			this.$router.push('/evaluate/mange');
		},

		goStudentEvaluationDetails: function(){
			this.$router.push('/evaluate/detail');
		},

		goStudentEvaluationClassexchangelist: function(){
			this.$router.push('/evaluate/classexchangelist');
		},

        doQueryQrCode: function() {
            let params = {
                key:'bxe_schadm_info',
                appCode:'schadm'
            };
            _common.post({
                url: _config.SERVICE + '/base/pro/schadm/user/contact/getKfQRCode',
                params:params,
                success:(res)=>{
                    if('001'==res.resultCode){
                        this.kfQrCode = res.data.url;
                        qt_storage.sessionSet('kfQrCode', res.data.url);
                    }else{
                        _common.tips(res.resultMsg);

                    }
                },
                fail:()=>{
                    _common.tips('/base/pro/schadm/user/contact/getKfQRCode服务异常，请稍后重试')
                }
            });
        },

    // 查询引导
    queryGuide () {
      let guidStorage = window.localStorage.getItem('is_first_open')
      if (!guidStorage) {
        this.isShowGuideMask = true
      }
    },

	}
}
</script>



// WEBPACK FOOTER //
// src/components/index/Index.vue